import request from "../utils/request";

export const getProducts = '/product/outside/'

export function updateProductFromPink() {
    return request.request({
        url: '/product/outside/update',
        method: 'post'
    })
}

export function importProducts(file: File){
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/product/outside/import',
        method: 'post',
        data: formData
    })
}
